export default __webpack_public_path__ + "static/media/museums-icon.3c69bc63.svg";